import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigService, ConfigOptions } from '@wilson/config';
import { QualificationCategoryV2 } from '@wilson/interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QualificationCategoryV2Service {
  protected readonly http = inject(HttpClient);
  protected readonly config = inject<ConfigOptions>(ConfigService);

  public getCategories(): Observable<QualificationCategoryV2[]> {
    return this.http.get<QualificationCategoryV2[]>(
      `${this.config.host}/qualifications/categories`,
    );
  }
}
